import { useCallback } from 'react';
import { Drawer } from '@cad-arc';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { PatrolDrawerContent } from './patrol-drawer-content';

export const AdminStatusDrawer = function AdminStatusDrawer({
    unitId,
    statusId,
}: {
    unitId?: number;
    statusId?: number;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const { unitStateDataById } = useBootstrapState();
    const closeDrawer = useCallback(() => {
        drawerControls.close();
    }, [drawerControls]);
    const header =
        statusId && unitStateDataById[statusId] ? unitStateDataById[statusId].value : 'Admin';
    return (
        <Drawer variant="overlay" isOpen={true} size="lg" onClose={closeDrawer}>
            <PatrolDrawerContent
                header={header}
                attributeType="ADMIN_PATROL"
                unitId={unitId}
                statusId={statusId}
                closeDrawer={closeDrawer}
            />
        </Drawer>
    );
};

type AdminStatusDrawerType = typeof AdminStatusDrawer;
export type { AdminStatusDrawerType };
